import ReminderNotification from "../../../model/notification/reminder/ReminderNotification";
import {
	NEW_NOTIFICATION,
	NOTIFICATION_STATUS_UPDATED,
	NOTIFICATIONS_FETCHED,
	NOTIFICATIONS_IS_UNREAD_FETCHED,
	NOTIFICATIONS_MARKED_AS_READ
} from "./actionType";
import {Action} from "redux-actions";
import {Dispatch} from "react-redux";
import {api} from "../../../api/api";
import {OnFailure, OnSuccess} from "../actionHelpers";
import Toast from "../../../components/helper/Toast";
import {NotificationType} from "../../../model/notification/NotificationBase";
import * as moment from "moment";

/**
 * Notification fetched successful action.
 * @param {Array<NotificationType>} notifications all notifications from server.
 * @return {Action<NOTIFICATIONS_FETCHED>}
 */
export function notificationsFetched(notifications: Array<NotificationType>): Action<NOTIFICATIONS_FETCHED> {
	return {type: NOTIFICATIONS_FETCHED, payload: {notifications}};
}

/**
 * Notification fetched successful action.
 * @return {Action<NOTIFICATIONS_IS_UNREAD_FETCHED>}
 * @param isUnread
 */
export function notificationsIsUnreadFetched(isUnread: boolean): Action<NOTIFICATIONS_IS_UNREAD_FETCHED> {
	return {type: NOTIFICATIONS_IS_UNREAD_FETCHED, payload: {isUnread}};
}

export interface NotificationStatus {
	notificationId: string,
	read: boolean
}

/**
 * Notifications status update successful action
 * @param {NotificationStatus[]} data
 * @returns {Action<NOTIFICATION_STATUS_UPDATED>}
 */
function notificationsStatusUpdated(data: NotificationStatus[]): Action<NOTIFICATION_STATUS_UPDATED> {
	return {type: NOTIFICATION_STATUS_UPDATED, payload: {data}};
}

/**
 * New notification triggered action.
 * @param {ReminderNotification} notification notification data.
 * @return {Action<NEW_NOTIFICATION>}
 */
export function reminderNotificationTriggered(notification: NotificationType): Action<NEW_NOTIFICATION> {
	return {type: NEW_NOTIFICATION, payload: {notification}}
}

/**
 * All notification mark as read action
 */
export function notificationsAsReadMarked(): Action<{}> {
	return {type: NOTIFICATIONS_MARKED_AS_READ}
}

/**
 * Mark notifications as read.
 * @param notificationIds notification identifiers
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function markNotificationsAsRead(notificationIds: string[], onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		const data = notificationIds.map(nId => { return {notificationId: nId, read: true}});
		api.instance.notificationApi.setStatus(data).then(() => {
				dispatch(notificationsStatusUpdated(data));
				onSuccess();
			}
		).catch(onFailure);
	}
}

/**
 * Mark notifications as unread.
 * @param notificationIds notification identifiers
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function markNotificationsAsUnread(notificationIds: string[], onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		const data = notificationIds.map(nId => { return {notificationId: nId, read: false}});
		api.instance.notificationApi.setStatus(data).then(() => {
				dispatch(notificationsStatusUpdated(data));
				onSuccess();
			}
		).catch(onFailure);
	}
}

export function markAllAsRead(visibleFrom: moment.Moment, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.notificationApi.markAllAsRead(visibleFrom).then(() => {
				dispatch(notificationsAsReadMarked());
				onSuccess()
			}
		).catch(onFailure);
	}
}

/**
 * Trigger note notification.
 * @param {ReminderNotification} notification
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function triggerReminderNotification(notification: NotificationType) {
	return function(dispatch: Dispatch<any>) {
		Toast.notification(notification);
		dispatch(reminderNotificationTriggered(notification));
	}
}

